import { Text, Flex, Card } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { AutoColumn } from 'components/Column'
import { RowBetween } from 'components/Row'
import { CardBody } from '@pancakeswap/uikit'
import { BsDropletFill } from '@react-icons/all-files/bs/BsDropletFill'
import DoubleCurrencyLogo from 'components/DoubleLogo'

export const Tabs = styled.div`
  max-width: 100vw !important;
  padding: 0px 0px 0px 0px;
`
export const MobileView = styled(Flex)`
  width: 100%;
  flex-direction: column;
  justify-content: center;
  display: flex;
  align-items: center;
  @media (min-width: 800px) {
    display: none;
  }
`

export const FlexConnect = styled(Flex)`
  min-width: 80%;
  align-self: center;
  @media (min-width: 1000px) {
    min-width: 40%;
  }
`

export const PositionDetailsFlex = styled(Flex)`
  background: none;
  flex: 1;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-shadow: 0 0 24px #111;
`

export const MainFlex = styled(Flex)`
  border-radius: 24px;
  background: none;

  box-shadow: 0 0 24px #111;
  min-height: 30px;
  width: 100%;
  margin-left: 4px;
  margin-right: 4px;
  @media (min-width: 1000px) {
    min-height: 68px;
  }
`

export const LPTokenDetail = styled(Flex)`
  margin: 4px;
`

export const TokensInLP = styled(Flex)`
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`

export const V2LiquidityCard = styled(Card)`
  border: 1px solid;
  background: ${({ theme }) => theme.colors.darkblue100};
  border-color: ${({ theme }) => theme.colors.input};
  width: 99%;
  height: 100%;
  padding: 4px;
  border-radius: 18px;
  margin-left: auto;
  margin-right: auto;

  @media (min-width: 1000px) {
    width: 90%;
  }
`

export const V2Double = styled(DoubleCurrencyLogo)`
  width: 24px;
  height: 24px;
  @media (min-width: 1000px) {
    width: 40px;
    height: 40px;
  }
`

export const ShowMore = styled(Flex)`
  border-top-right-radius: 8px;
  width: 100%;
  background: ${({ theme }) => theme.colors.darkblue100};
  border-top-left-radius: 8px;
  flex-direction: column;
  padding-left: 8px;
  padding-right: 8px;
  margin-top: 4px;
  border-top: 1px solid;
  border-color: ${({ theme }) => theme.colors.primary};
`

export const FixedHeightRow = styled(RowBetween)`
  height: 24px;
`

export const WalletDroplet = styled(BsDropletFill)`
  width: 20px;
  height: 20px;
  color: #dffe00;
  margin-right: 2px;
`

export const DesktopView = styled(Flex)`
  display: none;
  @media (min-width: 800px) {
    display: flex;
    margin-bottom: 8px;
  }
`

export const TypeTitle = styled(Text)`
  font-weight: 500;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-size: 24px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`

export const TypeSubtitle = styled(Text)`
  font-weight: 500;
  color: #fff;
  text-align: center;
  text-transform: uppercase;
  font-size: 18px;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`

export const V3LiquidityWrapper = styled.div`
  display: flex;
  max-width: 99vw;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}
  padding: 16px; 
  padding-bottom: 0rem;
  min-height: 125vh; 
  ${({ theme }) => theme.mediaQueries.xs} {
  }
  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 24px; 
    padding-bottom: 20px;
  }

  ${({ theme }) => theme.mediaQueries.lg} {
    padding: 32px; 
    padding-bottom: 16px; 
    min-height: 125vh; 
  }
`

export const PageWrapper = styled(AutoColumn)`
  padding: 2px;
  max-width: 400px;

  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.mediaQueries.sm} {
    max-width: 600px;
    padding: 24px 8px 0px;
  }
  ${({ theme }) => theme.mediaQueries.lg} {
    max-width: 800px;
  }
`

export const Body = styled(Flex)`
  width: 100%;
  height: 100%;
  flex-direction: column;
`
//fix on width of the liquidity row cards

export const TitleRow = styled(RowBetween)`
  color: ${({ theme }) => theme.colors.text};
`

export const RemoveTitle = styled(Text)`
  font-weight: 500;
  color: #fff;
  text-align: left;
  margin-top: 1rem;
  margin-bottom: 1px;
  text-transform: uppercase;
  font-size: 24px;
  @media (min-width: 768px) {
    font-size: 36px;
    margin-bottom: 0px;
  }
`

export const BorderCard = styled.div`
  border: solid 1px ${({ theme }) => theme.colors.darkborder};
  border-radius: 24px;
  box-shadow: 0 0 24px -4px #111;
  padding: 8px 8px;
`
